import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { GetStakingRiskClassificationsThunk, GetStakingRiskProductByIDThunk, UpdateAssessmentByIdThunk } from "../../../Store/Thunks/StakingRiskThunk";
import { Card, CardContent, CardHeader, CardTitle } from "../../../Components/StakingRisk/ui/card";
import AdditionalParameter from "./AdditionalParameter";
import ParameterRow from "./ParameterRow";
import ScoreSection from "./ScoreSection";


const riskMapping = {  
  0:[null],
  1: ["Low", "Mature", "Reliable", "Positive", "No Lawsuits", "No AML Activities", "Complied", "Compliant","Decentralized"],
  2: ["Medium", "Anonymous", "Standard","Moderate Compliance"],
  3: ["Immature", "Unreliable", "Negative", "Lawsuits Exist", "AML Activities", "Not Complied", "Limited", "Centralized",'High',"Non-Compliant"]
};

const levelToScore = {};
Object.entries(riskMapping).forEach(([score, levels]) => {
  levels.forEach(level => {
    levelToScore[level] = parseInt(score);
  });
});
levelToScore[" "] = 0;
levelToScore["Select..."] = 0; 

export default function AssetBlockchainTab({
  activeTab,
  assessments = [], 
  onUpdateScore,
  onAddParameter,
  isAsset = true
}) {
    const dispatch = useDispatch();
    const params = useParams();
    const tabType = isAsset ? "asset" : "blockchain";
    const title = isAsset ? "Asset Assessment" : "Blockchain Assessment";

    const assessmentupdate = useSelector((state) => state.StakingRiskReducer.assessmentupdate);
    const classifications = useSelector((state)=>{return state.StakingRiskReducer?.stakingRiskClassifications})
    const productId = useSelector((state) => state.StakingRiskReducer.createdStakingRiskId) || params.id;
    const productInfo = useSelector((state) => state.StakingRiskReducer.stakingRiskByID);
    const [riskScore, setRiskScore] = useState(null);
    const [riskLabel, setRiskLabel] = useState("Unknown");
 
  const classificationupdate = useSelector((state) => state.StakingRiskReducer.classificationupdate);
    const handleUpdateParameter = (id, newValue, newComment) => {
    dispatch(UpdateAssessmentByIdThunk(id,newValue,newComment))
    }; 



      useEffect(() => {
        if (classificationupdate || assessmentupdate) {
          dispatch(GetStakingRiskClassificationsThunk(productId));  
          dispatch(GetStakingRiskProductByIDThunk(productId)); 
        }
      }, [classificationupdate,assessmentupdate]);

      useEffect(() => {      
          let totalScore = 0;
          let count = 0;

          assessments.forEach(item => {
         
            const level = item.scoreLevel;
                  if (item.name === "Uptime" && level === "High") {
                    totalScore += 1;
                    count++;
                  }                   
                  else if (levelToScore[level]) {
                    totalScore += levelToScore[level];
                    count++;
                  }           
          });

          const avg = count > 0 ? totalScore / count : null;
         
          setRiskScore(avg?.toFixed(3) ?? 0);
          if (avg === null) setRiskLabel("Unknown");
          else if (avg <= 1.5) setRiskLabel("Low Risk");
          else if (avg <= 2.5) setRiskLabel("Medium Risk");
          else setRiskLabel("High Risk");
       
        }, [assessments, assessmentupdate]);
         
  return (
    <Card className="shadow-sm border-none">
      <CardHeader className="pb-3">
        <CardTitle>{title}</CardTitle>       
      </CardHeader>
      <CardContent>
        <div className="border rounded-md divide-y divide-gray-100 dark:divide-gray-800">
          {assessments.map((assessment) => {
            const {id, key, name, levels } = assessment;
            return (
              <ParameterRow
                id={id}
                key={key}
                label={name}
                isCustom={true}
                options={levels}
                value={assessment['scoreLevel'] || assessment?.[key]}
                comment={assessment['comment'] || assessment?.[`${key}Comment`]}
                onChange={(value, comment) => handleUpdateParameter(id, value, comment)}
              />
            );
          })}         
        </div>

       <AdditionalParameter onAddParameter={onAddParameter} id = {activeTab} />   
           
               <ScoreSection
                  id={activeTab}
                  updateProduct={() => {                    
                  }}
                  totalScorePercentage={parseFloat(classifications?.find((c) => c.key === tabType)?.totalScore || assessments?.totalScorePercentage)}
                  riskScore={riskScore ?? classifications.find((c) => c.key === tabType)?.automaticRiskScore } 
                  riskScoreType={ classifications?.find((c) => c.key === tabType)?.riskScoreType  ? classifications?.find((c) => c.key === tabType)?.riskScoreType  : 'automatic'} 
                  weightedRisk ={classifications?.find((c) => c.key === tabType)?.weightedScore}
                  riskLabel={riskLabel}
                  onUpdate={onUpdateScore}
                  automaticScoreLevel={classifications.find((c) => c.key === tabType)?.automaticScoreLevel || ""}
                  manualRiskScore={classifications.find((c) => c.key === tabType)?.manualRiskScore || 0}
                  manualScoreLevel={classifications.find((c) => c.key === tabType)?.manualScoreLevel || ""}
                  productInfo={productInfo}                                 
/>
      </CardContent>
    </Card>
  );
}